import { IconShield } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import type { ApiCall } from '../lib/api-call';
import { CopyAsCall } from './CopyAsCall';

// The mint's own disclosure: the exact call `<MintTokenModal/>`'s button would
// fire, plus the one thing an agent running it needs to know.
//
// Rendered from the DRAFT — the caller passes the same `ApiCall` the submit
// sends — so the copied command can never describe a different request, and the
// caller withholds this block entirely while the draft would be refused.

export type MintTokenDisclosureProps = {
  readonly call: ApiCall;
};

export function MintTokenDisclosure(props: MintTokenDisclosureProps): JSX.Element {
  return (
    <>
      <CopyAsCall calls={[{ label: t('account_tokens.mint'), call: props.call }]} />
      {/* The MCP call above is the one an agent runs to mint a token for itself.
          It forwards the CALLING token's own person, if any
          (`packages/mcp/src/army/token.ts`) — so a token minted by a token that
          carries nobody forwards nobody, all the way down the chain, and none of
          them can ever answer a blocker. */}
      <div class="alert alert--icon" role="note">
        <IconShield />
        <p class="alert__title">{t('account_tokens.mcp_mint_note_title')}</p>
        <p class="alert__desc">{t('account_tokens.mcp_mint_note_desc')}</p>
      </div>
    </>
  );
}
